export default () => ({

    positions: [1],

    element: (position) => ({
        ['x-intersect.half']() {
            return this.positions = [position];
        },
    }),

    multipleElements: (position) => ({
        ['x-intersect:enter.half']() {
            return this.positions.push(position);
        },

        ['x-intersect:leave.half']() {
            return this.positions = this.positions.filter(item => item !== position);
        },
    }),
});
